import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import IngredientsSearchContent from 'components/IngredientsSearch/IngredientsSearchContent';
import { ingredientTypeMap } from 'constants/ingredientType';
import {
  getPurchaseHistory,
  getPreviouslyUsed,
  getListIngredient,
  setSelectedTab,
  updateFilters,
  resetAllFilters,
  resetTabFilters,
  removeIngredientFromSelectedList,
  handleIngredientQtyUpdate,
  handleIngredientUnitUpdate,
  updateSortProps,
  updateSearchedTabs,
  getProductCatalogue,
  resetTab,
  saveNewCustomIngredient,
  getBatchRecipes,
  checkForCircularDependencies,
} from 'actions/ingredientsSearch';
import {
  purchasedWithinOptions,
  ingredientsSearchTabs,
  listDropDownDefault,
  sameIngredientExistsMessage,
  errorWhileCheckingCircularDependencyMessage,
  potentialCircularDependencyMessage,
} from 'constants/ingredientsSearch';
import { getWeightUnitTypes } from 'selectors/type-items';
import { getCurrentUserBrand } from 'selectors/user-brands';
import Ingredient from 'records/Ingredient';


@connect(state => ({
  ingredientsSearch: state.ingredientsSearch,
  selectedTab: state.ingredientsSearch.selectedTab,
  selectedFilters: state.ingredientsSearch.selectedFilters,
  selectedIngredients: state.ingredientsSearch.selectedIngredients,
  user: state.user.get('data'),
  loading: state.ingredientsSearch.loading,
  unitTypes: getWeightUnitTypes(state),
  brandId: getCurrentUserBrand(state).get('id'),
  commonCustomUom: state.customUom.get('common'),
}))
class IngredientReplacement extends Component {

  componentDidMount() {
    const { isFromNotificationCenter } = this.props;
    // fetch default purchase history for 26 weeks
    // only fetch this on componentDidMount for notification center ingredient replacement overlay.
    if(isFromNotificationCenter){
      this.fetchPurchaseHistory(purchasedWithinOptions[0].value);
    }
  }

  fetchPurchaseHistory = (purchasedWithinWeeks) => {
    const { dispatch } = this.props;
    dispatch(resetTabFilters(ingredientsSearchTabs.PURCHASE_HISTORY_TAB.key));
    return dispatch(getPurchaseHistory(purchasedWithinWeeks));
  };

  fetchPreviouslyUsed = (ingredType) => {
    const { dispatch, brandId } = this.props;
    return dispatch(getPreviouslyUsed(brandId, ingredType));
  };

  fetchListIngredient = (listId) => {
    const { dispatch } = this.props;
    return dispatch(getListIngredient(listId));
  }

  fetchProductCatalogue = keyword => {
    const { dispatch } = this.props;
    dispatch(resetTabFilters(ingredientsSearchTabs.FULL_PRODUCT_CATALOG_TAB.key));
    return dispatch(getProductCatalogue(keyword));
  };

  fetchBatchRecipes = () => {
    const { dispatch, isBatchRecipe, brandId } = this.props;
    if (isBatchRecipe) {
      dispatch(getBatchRecipes(brandId, 0));
    } else {
      dispatch(getBatchRecipes(brandId));
    }
  };

  changeSelectedTab = (tab) => {
    const { dispatch, ingredientsSearch, isFromNotificationCenter } = this.props;
    dispatch(setSelectedTab(tab));
    if (ingredientsSearch[tab].loaded) return;
    switch (tab) {
      case ingredientsSearchTabs.PREVIOUSLY_USED_TAB.key:
        this.fetchPreviouslyUsed(ingredientTypeMap.SYSCO_PRODUCTS);
        break;
      case ingredientsSearchTabs.PURCHASE_HISTORY_TAB.key:
        if (!isFromNotificationCenter) {
          this.fetchPurchaseHistory(purchasedWithinOptions[0].value);
        }
        break;
      case ingredientsSearchTabs.CUSTOM_INGREDIENTS_TAB.key:
        this.fetchPreviouslyUsed(ingredientTypeMap.CUSTOM_INGREDIENTS);
        break;
      case ingredientsSearchTabs.ITEM_LISTS_TAB.key:
        this.fetchListIngredient(listDropDownDefault.value);
        break;
      case ingredientsSearchTabs.BATCH_RECIPES_TAB.key:
        this.fetchBatchRecipes();
        break;
      default:
        break;
    }
  };

  changeFilterStatus = (facetId, filterId, isSelected) => {
    const { dispatch, selectedTab } = this.props;
    dispatch(updateFilters(selectedTab, facetId, filterId, isSelected));
  };

    /**
  * Change the state on error
  * @param {String} message error message to be shown
  */
    onErrorWhileCheckingCircularDependencies = message => {

      message = message || errorWhileCheckingCircularDependencyMessage
  
      this.setState({
        toggleErrorAlert: true,
        toggleAlertMessage: message,
      });
    }

  /**
   * Create ingredient Object to be added to the selected ingredients list and send to the store
   * @param {*} ingredient
   * @param {*} tab
   */
  onIngredientSelect = (ingredient, tab) => {
    const { recipe, brandId, recipeIngredients, selectedIngredients, handleSelectIngredient, isFromNotificationCenter } = this.props;

    if (isFromNotificationCenter) {
      const product = ingredient.product || ingredient; // for new custom ingredients, product == ingredient

      const ingredientObj = {
        recipeId: recipe.get('id'),
        brandId,
        ingredientName: ingredient.name,
        note: product.note ? product.note : product.ingredientName,
        ingredientBrand: product.brand || product.ingredientBrand,
        supc: product.supc,
        amount: product.amount,
        amountUnitTextKey: product.amountUnit ? product.amountUnit.toLowerCase() : product.baseUnitTextKey,
        baseUnitTextKey: product.amountUnit ? product.amountUnit.toLowerCase() : product.baseUnitTextKey,
        averageWtPerCase: product.averageWtPerCase,
        isCatchWeight: product.isCatchWeight,
        isSyscoBrand: ingredient.isSyscoBrand,
        packSizePack: product.packSizePack || product.pack,
        packSizeSize: product.packSizeSize || product.packSize,
        lastOrderedDate: product.lastOrderedDate,
        totalCost: product.unitCost,
        isSoldAs_split: product.isSoldAs_split,
        isSoldAs_case: product.isSoldAs_case,
        mainCategoryId: product.mainCategoryId,
        mainCategoryName: product.mainCategoryName,
        stockDesc: product.stockDesc,
        stockFlag: product.stockFlag,
        ordinal: Ingredient.getNextOrdinal(recipeIngredients) + selectedIngredients.length,
        amountUsedInRecipe: '',
        costPerServing: '',
        costPerUnit: product.costPerUnit,
        isCostPerServingLoading: false,
        uniqKey: uuidv4(),
        isQtyValid: true,
        id: product.id,
        tabName: tab,
      };

      handleSelectIngredient(ingredientObj);
    } else {
      this.createIngredientObject(ingredient, tab);
    }
  };

  createIngredientObject = (ingredient, tab) => {
    const { recipe, brandId, recipeIngredients, selectedIngredients, handleSelectIngredient, dispatch } = this.props;
    const product = ingredient.product || ingredient; // for new custom ingredients, product == ingredient

    const ingredientObj = {
      recipeId: recipe.get('id'),
      brandId,
      ingredientName: ingredient.name,
      note: product.note ? product.note : product.ingredientName,
      ingredientBrand: product.brand || product.ingredientBrand,
      supc: product.supc,
      amount: product.amount,
      amountUnitTextKey: product.amountUnit ? product.amountUnit.toLowerCase() : product.baseUnitTextKey,
      baseUnitTextKey: product.amountUnit ? product.amountUnit.toLowerCase() : product.baseUnitTextKey,
      averageWtPerCase: product.averageWtPerCase,
      isCatchWeight: product.isCatchWeight,
      isSyscoBrand: ingredient.isSyscoBrand,
      packSizePack: product.packSizePack || product.pack,
      packSizeSize: product.packSizeSize || product.packSize,
      lastOrderedDate: product.lastOrderedDate,
      totalCost: product.unitCost,
      isSoldAs_split: product.isSoldAs_split,
      isSoldAs_case: product.isSoldAs_case,
      mainCategoryId: product.mainCategoryId,
      mainCategoryName: product.mainCategoryName,
      stockDesc: product.stockDesc,
      stockFlag: product.stockFlag,
      ordinal: Ingredient.getNextOrdinal(recipeIngredients) + selectedIngredients.length,
      amountUsedInRecipe: '',
      costPerServing: '',
      isBatchRecipe: product.isBatchRecipe,
      batchRecipeId: tab === ingredientsSearchTabs.BATCH_RECIPES_TAB.key ? ingredient.id : -1,
      costPerUnit: product.costPerUnit,
      isCostPerServingLoading: false,
      uniqKey: uuidv4(),
      isQtyValid: true,
      id: product.id,
      tabName: tab,
    };

    if (tab === ingredientsSearchTabs.BATCH_RECIPES_TAB.key) {
            ingredientObj.costPerUnit = ingredient.costPerPortion;
            ingredientObj.amountUnitTextKey = ingredient.amountUnitTextKey;
            ingredientObj.baseUnitTextKey = ingredient.amountUnitTextKey;
            ingredientObj.averageWtPerCase = ingredient.averageWtPerCase;
            ingredientObj.isCatchWeight = ingredient.isCatchWeight;
            ingredientObj.packSizePack = ingredient.packSizePack;
            ingredientObj.packSizeSize = ingredient.packSizeSize;
            ingredientObj.isSoldAs_split = ingredient.isSoldAs_split;
            ingredientObj.isSoldAs_case = ingredient.isSoldAs_case;
            handleSelectIngredient(ingredientObj);
    } else {
      handleSelectIngredient(ingredientObj);
    }
  }

  onIngredientRemove = (removedIngredient) => {
    const { dispatch } = this.props;
    dispatch(removeIngredientFromSelectedList(removedIngredient));
  };

  onIngredientQtyUpdate = (ingredient, qty, isQtyValid) => {
    const { dispatch } = this.props;
    dispatch(handleIngredientQtyUpdate(ingredient, qty, isQtyValid));
  };

  onIngredientUnitUpdate = (ingredient, unit) => {
    const { dispatch } = this.props;
    dispatch(handleIngredientUnitUpdate(ingredient, unit));
  };

  resetFilters = () => {
    const { dispatch } = this.props;
    dispatch(resetAllFilters());
  };

  render() {
    const {
      selectedTab,
      ingredientsSearch,
      selectedFilters,
      selectedIngredients,
      unitTypes,
      recipe,
      loading,
      commonCustomUom,
      user,
      selectedKey,
      isFromNotificationCenter,
      ingredientReplacement
    } = this.props;

    return (
      <div className='modal-body-ingredient-search'>
        <IngredientsSearchContent
          fetchPurchaseHistory={ this.fetchPurchaseHistory }
          fetchListIngredient={ this.fetchListIngredient }
          selectedTab={ selectedTab }
          ingredientsSearch={ ingredientsSearch }
          changeSelectedTab={ this.changeSelectedTab }
          changeFilterStatus={ this.changeFilterStatus }
          selectedFilters={ selectedFilters[selectedTab] }
          onIngredientSelect={ this.onIngredientSelect }
          onIngredientRemove={ this.onIngredientRemove }
          selectedIngredients={ selectedIngredients }
          onIngredientQtyUpdate={ this.onIngredientQtyUpdate }
          onIngredientUnitUpdate={ this.onIngredientUnitUpdate }
          unitTypes={ unitTypes }
          updateSortProps={ this.updateSortProps }
          updateSearchedTabs={ this.updateSearchedTabs }
          fetchProductCatalogue={ this.fetchProductCatalogue }
          resetTab={ this.resetTab }
          recipeId={ recipe.get('id') }
          loading={ loading }
          onNewCustomIngredientSave={ this.onNewCustomIngredientSave }
          commonCustomUom={ commonCustomUom }
          userCountry={ user.get('country') }
          isIngredientReplacement={ true }
          selectedKey={ selectedKey }
          isFromNotificationCenter={ isFromNotificationCenter }
          ingredientReplacement={ ingredientReplacement }
        />
      </div>
    );
  }

  /**
   * update product list for a given specific tab
   * @param {String} tabKey tabKey of the products
   * @param {List} products updated product list
   * @param {Object} sort sort properties eg: {sorted:true, sortColumn:'a', sortDirection:'ASC'}
   */
  updateSortProps = (tabKey, sort = { sorted: false }) => {
    this.props.dispatch(updateSortProps(tabKey, sort));
  }

  /**
   * update searched tabs
   * @param {String} tabKey tabKey
   */
  updateSearchedTabs = updatedSearchedTabs => {
    this.props.dispatch(updateSearchedTabs(updatedSearchedTabs));
  }

  /**
   * Reset products and filters for a given tab
   * @param {String} tabKey tabkey
   */
  resetTab = tabKey => {
    this.props.dispatch(resetTab(tabKey));
  }

  /**
   * Save new ingredient in the DB
   * @param {Object} ingredient ingredient object to be inserted
   */
  onNewCustomIngredientSave = ingredient => {
    const { ingredientsSearch, dispatch } = this.props;
    const products = ingredientsSearch[ingredientsSearchTabs.CUSTOM_INGREDIENTS_TAB.key].products || [];
    const newIngredients = ingredientsSearch[ingredientsSearchTabs.CUSTOM_INGREDIENTS_TAB.key].newIngredients || [];

    const mappedIngredient = {
      amountUnitTextKey: ingredient.unit,
      amountUsedInRecipe: 0,
      baseUnitTextKey: ingredient.unit,
      batchRecipeId: "-1",
      costPerServing: 0,
      costPerUnit: ingredient.cost,
      ingredientName: ingredient.name,
      ingredientBrand: ingredient.brand,
      recipeId: null,
      isSyscoBrand: false,
      note: "",
      ordinal: 0,
      supc: "",
      key: ingredient.key,
    };

    if (
      products.filter(product =>
        mappedIngredient.ingredientName === product.ingredientName &&
        mappedIngredient.ingredientBrand === product.ingredientBrand).length ||
      newIngredients.filter(product =>
        mappedIngredient.ingredientName === product.ingredientName &&
        mappedIngredient.ingredientBrand === product.ingredientBrand).length
    ) {
      return this.onError(sameIngredientExistsMessage);
    }
    return dispatch(saveNewCustomIngredient(mappedIngredient, error =>
      this.onError(error.message === sameIngredientExistsMessage.toLowerCase() ? sameIngredientExistsMessage : null)));
  }
}

IngredientReplacement.propTypes = {
  dispatch: PropTypes.func,
  recipe: PropTypes.object,
  selectedTab: PropTypes.string,
  selectedFilters: PropTypes.object,
  ingredientsSearch: PropTypes.object,
  selectedIngredients: PropTypes.array,
  loading: PropTypes.bool,
  unitTypes: PropTypes.object,
  recipeIngredients: PropTypes.object,
  commonCustomUom: PropTypes.object,
  user: PropTypes.object,
  brandId: PropTypes.number,
  handleSelectIngredient: PropTypes.func,
  selectedKey: PropTypes.string,
  isFromNotificationCenter: PropTypes.bool,
  ingredientReplacement: PropTypes.object,
};

export default IngredientReplacement;
